import Layout from "../../components/Layout";
import { penghargaanKamiMeta, defaultURL } from "../../data/DataMetatags";
import NextHead from "../../components/Seo/NextHead";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { penghargaanKamiBreadcrumb } from "../../data/DataBreadcrumb";
import AwardsBlocks from "../../components/Awards/AwardsBlocks";

const penghargaanKami = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={penghargaanKamiBreadcrumb} />
      <AwardsBlocks></AwardsBlocks>
    </Layout>
  );
};

penghargaanKami.getInitialProps = ({ asPath }) => {
  const pageTitle = penghargaanKamiMeta.title;
  const descriptionSEO = penghargaanKamiMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};

export default penghargaanKami;
